import PropTypes from 'prop-types'
import React from 'react'
import focusable from '../../components/Focusable/Focusable'
import LogoHeader from '../../components/LogoHeader/LogoHeader'

class Modal extends React.Component {
  constructor(props) {
    super(props)

    this.componentType = props.componentType
  }

  render() {
    const { children, error, hideStationLogo } = this.props

    return (
      <div className={`modal-style ${error ? 'active' : ''}`}>
        {!hideStationLogo && <LogoHeader />}
        <div className="content-style">{children}</div>
      </div>
    )
  }
}

Modal.propTypes = {
  children: PropTypes.array,
  componentType: PropTypes.string,
  contentStyle: PropTypes.object,
  error: PropTypes.bool,
  hasFocus: PropTypes.bool,
  hideStationLogo: PropTypes.bool,
  modalStyle: PropTypes.object,
}

export default focusable(Modal)
